import React, { useEffect } from 'react';
import Navbar from '../components/karma/Navbar';
import Hero from '../components/karma/Hero';
import Welcome from '../components/karma/Welcome';
import HowItWorks from '../components/karma/HowItWorks';
import WhatsIncluded from '../components/karma/WhatsIncluded';
import DiscoverWorld from '../components/karma/DiscoverWorld';
import DestinationChapter from '../components/karma/DestinationChapter';
import EditorialGrid from '../components/karma/EditorialGrid';
import PullQuote from '../components/karma/PullQuote';
import TrustSection from '../components/karma/TrustSection';
import FAQ from '../components/karma/FAQ';
import ImportantInfo from '../components/karma/ImportantInfo';
import FinalCTA from '../components/karma/FinalCTA';
import Footer from '../components/karma/Footer';
import ScrollProgress from '../components/karma/ScrollProgress';
import MobileStickyBar from '../components/karma/MobileStickyBar';
import { destinations } from '../mock';

const Home = () => {
  // Reveal on scroll observer
  useEffect(() => {
    const els = document.querySelectorAll('.reveal');
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('visible');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <div className="bg-cream min-h-screen">
      <ScrollProgress />
      <Navbar />
      <Hero />
      <Welcome />
      <HowItWorks />
      <WhatsIncluded />
      <DiscoverWorld />

      {destinations.map((d, i) => (
        <React.Fragment key={d.id}>
          <DestinationChapter destination={d} />
          {i === 2 && (
            <PullQuote
              quote="The finest journeys are not measured in miles, but in moments quietly gathered."
              author="Karma Experience"
            />
          )}
          {i === 4 && (
            <PullQuote
              quote="Every journey here tells a story. Which one will be yours?"
              author="Karma Experience"
            />
          )}
        </React.Fragment>
      ))}

      <EditorialGrid />
      <TrustSection />
      <FAQ />
      <ImportantInfo />
      <FinalCTA />
      <Footer />
      <MobileStickyBar />
    </div>
  );
};

export default Home;
